import { render, staticRenderFns } from "./CookieSettingsBanner.vue?vue&type=template&id=46ec9ee9&scoped=true&"
import script from "./CookieSettingsBanner.vue?vue&type=script&lang=js&"
export * from "./CookieSettingsBanner.vue?vue&type=script&lang=js&"
import style0 from "./CookieSettingsBanner.vue?vue&type=style&index=0&id=46ec9ee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ec9ee9",
  null
  
)

export default component.exports